function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "4.5179mm",
    height: "4.2968mm",
    viewBox: "0 0 49 49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M13 0c3,0 6,0 9,0l0 5c5,1 9,6 9,12l0 7 4 5 0 5c-13,0 -22,0 -35,0l0 -5 4 -5 0 -7c0,-6 4,-11 9,-12l0 -5zm11 37c-1,3 -4,4 -6,4 -3,0 -6,-1 -7,-4l13 0z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.05ea27dd2bf0cb8ed19a96bb71bb44c2.svg";
export { ForwardRef as ReactComponent };